<template>
    <div class="trend">
        <div class="title">整体趋势</div>
        <div class="trendContetn clear">
            <div class="trendItem ddItem">
                <p class="itemName">浏览人数</p>
                <p class="itemBg icon1"></p>
                <p class="itemNum">{{trendData.totalLook}}</p>
                <p class="ItemUnits">人</p>
            </div>
            <div class="trendItem ddItem">
                <p class="itemName">人均门票价</p>
                <p class="itemBg icon2"></p>
                <p class="itemNum">{{Math.floor(trendData.avgTicket * 100) / 100}}</p>
                <p class="ItemUnits">元</p>
            </div>
            <div class="trendItem ddItem">
                <p class="itemName">历史累计收益</p>
                <p class="itemBg icon3"></p>
                <p class="itemNum">{{trendData.allEarningsAmount}}</p>
                <p class="ItemUnits">元</p>
            </div>
            <div class="trendItem cItem">
                <p class="itemName">举办活动数</p>
                <div class="cItemContent">
                    <div class="flexItem">
                        <p class="itemBg icon3"></p>
                        <p class="itemNum">{{trendData.gamesCount}}</p>
                        <p class="ItemUnits">场赛事</p>
                    </div>
                    <div class="flexItem">
                        <p class="itemBg icon4"></p>
                        <p class="itemNum">{{trendData.leaderCount}}</p>
                        <p class="ItemUnits">场大师课</p>
                    </div>
                    <div class="flexItem">
                        <p class="itemBg icon5"></p>
                        <p class="itemNum">{{trendData.activityCount}}</p>
                        <p class="ItemUnits">场演出活动</p>
                    </div>
                </div>
            </div>
            <div class="trendItem cItem">
                <p class="itemName">门票累计销量</p>
                <div class="cItemContent">
                    <div class="flexItem">
                        <p class="itemBg icon3"></p>
                        <p class="itemNum">{{trendData.playerTotal}}</p>
                        <p class="ItemUnits">张选手票</p>
                    </div>
                    <div class="flexItem">
                        <p class="itemBg icon4"></p>
                        <p class="itemNum">{{trendData.lessonsTotal}}</p>
                        <p class="ItemUnits">张大师课票</p>
                    </div>
                    <div class="flexItem">
                        <p class="itemBg icon5"></p>
                        <p class="itemNum">{{trendData.audienceTotal}}</p>
                        <p class="ItemUnits">张观众票</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            trendData: {}
        }
    },
    methods: {
        getDetails(data) {
            this.trendData = data;
        }
    },
}
</script>

<style lang="scss" scoped>
.title{
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 13px;
}
.trendContetn{
    background-color: #292941;
    border-radius: 12px;
    padding: 24px 8px 0 24px;
}
.trendItem{
    margin-bottom: 24px;
    .itemName{
        font-size: 16px;
        color: #fff;
        padding: 16px 0 0 16px;
    }
    .itemBg{
        width: 40px;
        height: 40px;
        margin: 34px auto 16px;
    }
    .itemBg.icon1{
        background: url('../../../../../assets/images/myData/group.png') center center / 30px 30px no-repeat;
    }
    .itemBg.icon2{
        background: url('../../../../../assets/images/myData/ticket.png') center center / 34px 34px no-repeat;
    }
    .itemBg.icon3{
        background: url('../../../../../assets/images/myData/money.png') center center / 38px 38px no-repeat;
    }
    .itemBg.icon4{
        background: url('../../../../../assets/images/myData/icon1.png') center center / 27px 27px no-repeat;
    }
    .itemBg.icon5{
        background: url('../../../../../assets/images/myData/icon2.png') center center / 40px 40px no-repeat;
    }
    .itemBg.icon6{
        background: url('../../../../../assets/images/myData/icon3.png') center center / 36px 36px no-repeat;
    }
    .itemNum{
        font-size: 26px;
        text-align: center;
        color: #fff;
    }
    .ItemUnits{
        color: #A1A1CC;
        font-size: 14px;
        text-align: center;
        margin-top: 12px;
    }
}
.ddItem{
    width: 200px;
    height: 200px;
    line-height: 1;
    background-color: #22223A;
    border-radius: 12px;
    margin-right: 16px;
    float: left;
}
.cItem{
    width: 469px;
    height: 200px;
    line-height: 1;
    background-color: #22223A;
    border-radius: 12px;
    margin-right: 16px;
    float: left;
}
.cItemContent{
    display: flex;
    flex-direction: row;
    .flexItem{
        flex: 1;
    }
}
</style>
